export const SETUP_GUIDE_DEFAULT_GRID_SIZE = 12;
export const SETUP_GUIDE_CHECKLIST_GRID_SIZE = 4;
export const SETUP_GUIDE_TWO_COLUMNS_BREAKPOINT_PX = 1124;